import React from 'react';

const AlertBox = (props) => {
    const { alertType, heading, message } = props;
    return (
        <div className="container">
            <div className={`alert alert-${alertType}`} role="alert">
                <h4 className="alert-heading">{heading}</h4>
                <p>{message}</p>
            </div>
        </div>
    );
}

export default AlertBox;